<template>
  <header class="header" id="header">

    <b-navbar
      toggleable="md"
      type="dark"
      variant="bb-dark"
      fixed="top"
      class="bb-navbar"
    >

      <div class="container">

        <b-navbar-brand :to="{ name: 'home' }">
          <div class="d-inline-block" aria-hidden="true">
            <BrandIcon />
          </div>
          BEACH-BUILT
        </b-navbar-brand>

        <b-navbar-toggle
          target="navCollapse"
          class="hamburger hamburger--collapse"
          :class="{ 'is-active': isActive }">
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </b-navbar-toggle>

        <b-collapse is-nav id="navCollapse">
          <b-navbar-nav class="">
            <b-nav-item :to="{ name: 'about' }">
              <span class="icon-user" aria-hidden="true"></span>
              About
            </b-nav-item>
            <b-nav-item :to="{ name: 'bootcamp' } ">
              <span class="icon-kettlebell-2" aria-hidden="true"></span>
              Bootcamp
            </b-nav-item>
            <b-nav-item :to="{ name: 'services' }">
              <span class="icon-heart-pulse" aria-hidden="true"></span>
              Services
            </b-nav-item>
            <b-nav-item :to="{ name: 'testimonials' }">
              <span class="icon-bubble" aria-hidden="true"></span>
              Testimonials
            </b-nav-item>
            <b-nav-item :to="{ name: 'contact' }">
              <span class="icon-envelope" aria-hidden="true"></span>
              Contact
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>

      </div>

    </b-navbar>

  </header>
</template>

<script>
import BrandIcon from '@/components/BrandIcon'
export default {
  components: {
    BrandIcon
  },

  data () {
    return {
      isActive: false
    }
  },

  watch: {
    $route (to, from) {
      // Fix nav collapse issue when clicking logo
      if (to.name === 'home' && this.isActive) {
        this.$root.$emit('bv::toggle::collapse', 'navCollapse')
      }
    }
  },

  created () {
    this.$root.$on('bv::collapse::state', (id, show) => {
      this.isActive = show
    })
  }
}
</script>
